import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @return {?}
 */
export function RequiredSelectValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control.value === '0' || !control.value) {
      return { requiredSelect: { value: control.value } };
    }

    return null;
  };
}
